import AxiosService from 'services/AxiosService';
import { getDisplayNames } from '@kizen/api/records';
import useCustomObjectDetails from 'components/Wizards/shared/hooks/useCustomObjectDetails';
import { useJsActionOverride } from 'ts-components/Plugins/jsActions';

export const useRelationshipActionOverride = (relatedObjectId) => {
  const { data: details } = useCustomObjectDetails({
    objectId: relatedObjectId,
    enabled: Boolean(relatedObjectId),
  });

  const { jsAction, execute, pending, indicator } = useJsActionOverride(
    relatedObjectId,
    {
      jsActions: details?.browserJsActions,
      overrideKey: details?.actionOverrideCreate,
    }
  );

  const executeOverride = jsAction
    ? async (entityCreatedHandler) => {
        const recordId = await execute();
        if (recordId && typeof recordId === 'string') {
          const displayName = await getDisplayNames(AxiosService, {
            record_ids: [recordId],
          })
            .then((r) => r.results?.records?.[0]?.display_name ?? '')
            .catch(() => '');
          await entityCreatedHandler({
            id: recordId,
            display_name: displayName,
          });
        }
      }
    : null;

  return { executeOverride, pending, indicator };
};
